import { graphqlRequest } from "../apiClient";

export const TERMS_DOCUMENT_ID = "terms_and_conditions";

const LIST_VERSIONS = `
  query PlatformLegalVersions {
    platformLegalVersions {
      document_id
      version
      status
      content_hash
      created_at
      published_at
    }
  }
`;

const LEGAL_COVERAGE = `
  query PlatformLegalCoverage($versionId: ID) {
    platformLegalCoverage(version_id: $versionId) {
      document_id
      version
      covered_count
      missing_count
      covered {
        tenant_id
        tenant_name
        version
        accepted_at
        accepted_by_email
      }
      missing {
        tenant_id
        tenant_name
      }
    }
  }
`;

const LIST_ACCEPTANCES = `
  query ListLegalAcceptances($tenantId: String) {
    listLegalAcceptances(tenant_id: $tenantId, limit: 50) {
      items {
        tenant_id
        document_id
        version
        accepted_at
        accepted_by_email
        context
      }
    }
  }
`;

const CREATE_UPLOAD = `
  mutation CreateLegalDocumentUploadUrl($input: CreateLegalDocumentUploadInput!) {
    createLegalDocumentUploadUrl(input: $input) {
      upload_id
      upload_url
      expires_at
      s3_key
    }
  }
`;

const PUBLISH = `
  mutation PlatformPublishLegalVersion($input: PublishLegalVersionInput!) {
    platformPublishLegalVersion(input: $input) {
      version
      status
      published_at
    }
  }
`;

const ROLLBACK = `
  mutation PlatformRollbackLegalVersion($versionId: ID!) {
    platformRollbackLegalVersion(version_id: $versionId) {
      version
      status
      published_at
    }
  }
`;

export async function fetchLegalVersions() {
  const data = await graphqlRequest(LIST_VERSIONS);
  return data?.platformLegalVersions || [];
}

export async function fetchLegalCoverage(versionId) {
  const data = await graphqlRequest(LEGAL_COVERAGE, { versionId: versionId || null });
  return data?.platformLegalCoverage;
}

export async function searchLegalAcceptances(tenantId) {
  const data = await graphqlRequest(LIST_ACCEPTANCES, { tenantId: tenantId || null });
  return data?.listLegalAcceptances?.items || [];
}

export async function createLegalDocumentUploadUrl(file, documentId = TERMS_DOCUMENT_ID) {
  const data = await graphqlRequest(CREATE_UPLOAD, {
    input: {
      document_id: documentId,
      file_name: file.name || "terms.html",
      mime_type: file.type || "text/html",
      content_length: file.size,
    },
  });
  return data?.createLegalDocumentUploadUrl;
}

export async function publishLegalVersion(version, documentId = TERMS_DOCUMENT_ID) {
  const data = await graphqlRequest(PUBLISH, {
    input: { document_id: documentId, version },
  });
  return data?.platformPublishLegalVersion;
}

export async function rollbackLegalVersion(versionId) {
  const data = await graphqlRequest(ROLLBACK, { versionId: String(versionId) });
  return data?.platformRollbackLegalVersion;
}
